export default __webpack_public_path__ + "static/media/Messages.de7f83f6.svg";